export default __webpack_public_path__ + "static/media/OneMoreSkills.2dddf114.svg";